import { ReactElement } from 'react';
import { useTranslate } from '@client/i18n/hooks/useTranslate';
import { Props } from '@client/product/components/ProductActions/PDFAction/PDFContent';
import { PDFContent as CorePDFContent } from '@client/product/components/ProductActions/PDFAction/PDFContent/PDFContent';

export const PDFContent = (props: Props): ReactElement => {
  const t = useTranslate();
  const { effectivePricing } = props.product;
  const text = {
    listPrice: t(
      'Compare Price <strong>incl.</strong> {taxRate} VAT',
      {
        taxRate: `${effectivePricing.priceTaxRate}%`,
      },
      'Compare Price (Vergleichspreis) with VAT',
    ),
    listPriceWithoutVat: t(
      'Compare Price <strong>excl.</strong> {taxRate} VAT',
      {
        taxRate: `${effectivePricing.priceTaxRate}%`,
      },
      'Compare Price (Vergleichspreis) without VAT',
    ),
  };

  return <CorePDFContent {...props} text={text} />;
};
